import { createFileRoute } from "@tanstack/react-router";

import { CoachProductPage } from "src/pages/CoachProductPage";

export const Route = createFileRoute(
  "/_auth/_coach/products/$productId/_tabs/",
)({
  component: CoachProductPage,
  ssr: true,
});
